import React from 'react';
import {AUTH_TOKEN_STORAGE_KEY} from '../constants/storageConstants';
import {logoutMutation} from '../qql-shared/mutations';

import {graphql} from 'react-apollo';
import {LogoutItem} from './SidebarContent';

const Logout = ({mutate}) => {
  return (
    <LogoutItem
      onClick={() => {
        mutate().then(response => {
          localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
          window.location.reload();
        });
      }}>
      Abmelden
    </LogoutItem>
  );
};

export default graphql(logoutMutation)(Logout);



// WEBPACK FOOTER //
// ./src/components/Logout.js